<template>
    <img src="/public/assets/images/diplome-cambridge-image.jpg" />
</template>

<script>
export default {
    name: "DiplomeCambridgePage",
    components: {},
    data: () => ({
        
    }),
    methods: {
        
    },
    mounted() {
        
    }
}
</script>